import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import "./campaign_configuration.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { Dialog } from "@progress/kendo-react-dialogs";
import BackIcon from "../../../assets/communication/Back.svg";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST, REWARDS_INVENTORY_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import Docfile from "../../../assets/rewards/file.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { TextBox } from "@progress/kendo-react-inputs";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
import { createAndUpdateCampaignRewardProvider, fetchGlobalConfigList, updateGlobalConfig, updateModuleConfigurationStatus } from "../../../store/campaign_configuration";
const { CAMPAIGN_IMAGE_UPLOAD_ENDPOINT } = config.api_endpoint;

export const CreateUpdateCampaignGlobalConfig = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userPermissions = getUserPermission();

  const AddPermission = checkPermission(
    userPermissions,
    "admin_tools.update_campaign_configuration"
  );

  const [loading, setLoading] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);


  const [error, setError] = useState({
    MAX_COUPONS: "",
    RESET_PERIOD_MONTHS: "",
  });


  const [editData, setEditData] = useState({
    MAX_COUPONS: "",
    RESET_PERIOD_MONTHS: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    dispatch(fetchGlobalConfigList()).then((res) => {


      let payload = res.payload.data;

      setEditData({
        ...editData,
        MAX_COUPONS: payload.MAX_COUPONS.value,
        RESET_PERIOD_MONTHS: payload.RESET_PERIOD_MONTHS.value
      });

      setLoading(false);

    });
  };


  const checkMandatoryFields = () => {

    const { MAX_COUPONS, RESET_PERIOD_MONTHS } = editData;



    if (!MAX_COUPONS || !RESET_PERIOD_MONTHS) {
      setShowRequiredFieldError(true);
      return true;
    }



  };



  const handleSubmit = () => {
    if (checkMandatoryFields()) return;


    setLoading(true);

    let updatedData = { ...editData };


    dispatch(updateGlobalConfig({ data: updatedData })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        getData();

        setLoading(false);

        redirectListing();

      } else {
        setLoading(false);



      }
    });



  };

  const redirectListing = () => {
    navigate(`${ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST}?tab=global_config`);
  }




  return (
    <>
      {AddPermission ? (
        <div style={{ height: "calc(100% - 75px)" }}>



          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {(loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="campaign-configuration-body">
            <div className="campaign-configuration-add-header" >
              <div className="back-title-group" onClick={(e) => redirectListing()}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="campaign-configuration-container">
            <div className="main-campaign-configuration">
              <div className="campaign-configuration-scroll-box">
                <div>
                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration-header">
                      Max Claim Coupons
                    </div>

                    <div className="campaign-configuration_create_item_main_box_title">
                      The value for Max Claim
                    </div>
                    <div>
                      <TextBox
                        className="campaign-configuration_create_item_main_box_field"
                        value={editData.MAX_COUPONS}
                        disabled={!AddPermission}
                        inputMode="numeric"
                        maxLength={2}
                        onChange={(e) => {
                          let val = e.target.value;

                          if (/^\d*$/.test(val)) {
                            setEditData({
                              ...editData,
                              MAX_COUPONS: val,
                            })
                          }

                        }}
                      />
                      {error.MAX_COUPONS !== "" && (
                        <div className="campaign-configuration_create_error_text">
                          {error.MAX_COUPONS}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="campaign-configuration_create_item_main_box">

                    <div className="campaign-configuration_create_item_main_box_title">
                      Points Reset Period (Month)
                    </div>
                    <div>
                      <TextBox
                        className="campaign-configuration_create_item_main_box_field"
                        value={editData.RESET_PERIOD_MONTHS}
                        disabled={!AddPermission}
                        inputMode="numeric"
                        maxLength={2}
                        onChange={(e) => {
                          let val = e.target.value;


                          if (/^\d*$/.test(val)) {
                            setEditData({
                              ...editData,
                              RESET_PERIOD_MONTHS: val,
                            })
                          }

                        }}
                      />
                      {error.RESET_PERIOD_MONTHS !== "" && (
                        <div className="campaign-configuration_create_error_text">
                          {error.RESET_PERIOD_MONTHS}
                        </div>
                      )}
                    </div>
                  </div>





                </div>



              </div>

            </div>

            <div className="campaign-configuration-footer">
              <div className="footer-left-btn-groups"></div>

              <div className="campaign-configuration-footer-right">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    redirectListing();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>



            </div>
          </div>


        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
